/**
 * Development Update Types
 * For "What's New" / Development Updates feature with RBAC visibility
 */
export var UpdateCategory;
(function (UpdateCategory) {
    UpdateCategory["NEW_FEATURE"] = "new-feature";
    UpdateCategory["ENHANCEMENT"] = "enhancement";
    UpdateCategory["BUG_FIX"] = "bug-fix";
    UpdateCategory["SECURITY"] = "security";
    UpdateCategory["PERFORMANCE"] = "performance";
    UpdateCategory["UI_UX"] = "ui-ux";
    UpdateCategory["API"] = "api";
    UpdateCategory["MAINTENANCE"] = "maintenance";
})(UpdateCategory || (UpdateCategory = {}));
export var UpdateStatus;
(function (UpdateStatus) {
    UpdateStatus["COMPLETED"] = "completed";
    UpdateStatus["IN_PROGRESS"] = "in-progress";
    UpdateStatus["PLANNED"] = "planned";
})(UpdateStatus || (UpdateStatus = {}));
/**
 * Category configuration for UI display
 * Note: icon field is now just the icon name, actual React icon component rendered in UI
 */
export const UPDATE_CATEGORY_CONFIG = {
    [UpdateCategory.NEW_FEATURE]: {
        label: 'New Feature',
        color: '#22c55e',
        icon: 'FaStar', // React icon name
        description: 'Brand new functionality added to the platform'
    },
    [UpdateCategory.ENHANCEMENT]: {
        label: 'Enhancement',
        color: '#3b82f6',
        icon: 'FaRocket', // React icon name
        description: 'Improvements to existing features'
    },
    [UpdateCategory.BUG_FIX]: {
        label: 'Bug Fix',
        color: '#ef4444',
        icon: 'FaBug', // React icon name
        description: 'Issues resolved and bugs fixed'
    },
    [UpdateCategory.SECURITY]: {
        label: 'Security',
        color: '#f59e0b',
        icon: 'FaShieldAlt', // React icon name
        description: 'Security improvements and patches'
    },
    [UpdateCategory.PERFORMANCE]: {
        label: 'Performance',
        color: '#8b5cf6',
        icon: 'FaBolt', // React icon name
        description: 'Speed and performance optimizations'
    },
    [UpdateCategory.UI_UX]: {
        label: 'UI/UX',
        color: '#ec4899',
        icon: 'FaPalette', // React icon name
        description: 'User interface and experience improvements'
    },
    [UpdateCategory.API]: {
        label: 'API',
        color: '#06b6d4',
        icon: 'FaPlug', // React icon name
        description: 'API changes and integrations'
    },
    [UpdateCategory.MAINTENANCE]: {
        label: 'Maintenance',
        color: '#6b7280',
        icon: 'FaTools', // React icon name
        description: 'System maintenance and updates'
    }
};
/**
 * Status configuration for UI display
 * Note: icon field is now just the icon name, actual React icon component rendered in UI
 */
export const UPDATE_STATUS_CONFIG = {
    [UpdateStatus.COMPLETED]: {
        label: 'Completed',
        color: '#22c55e',
        icon: 'FaCheckCircle' // React icon name
    },
    [UpdateStatus.IN_PROGRESS]: {
        label: 'In Progress',
        color: '#3b82f6',
        icon: 'FaSync' // React icon name
    },
    [UpdateStatus.PLANNED]: {
        label: 'Planned',
        color: '#6b7280',
        icon: 'FaCalendarAlt' // React icon name
    }
};
